// extracted by css-extract-rspack-plugin
export default {"root":"X_4A6cOvWUjJ1Dni","svg":"nCKFGFSwnx0_AMLm","error":"boFvx9HRwE07zGiq"};